import React, { Component } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { setForm } from '../actions/formulaire'

class Checkbox extends Component {

  constructor(props){
    super(props);
    this.state = {
      value : false
    }
  }

  handleClick(){
    this.props.setForm({seance : this.props.id});
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.form.seance === this.props.id){
      this.setState({value : true});
    }else{
      this.setState({value : false});
    }
  }

  render() {
    return (
      <div className="checkbox" >
        <input type="checkbox" onClick={this.handleClick.bind(this)} id={this.props.id} checked={this.state.value} />
        <label htmlFor={this.props.id} >{this.props.label}</label>
      </div>
     )
  }

}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
    setForm : setForm
  },dispatch)
}

function mapStateToProps(state) {
  return {
    form : state.form
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Checkbox);



// WEBPACK FOOTER //
// ./src/client/components/checkbox.js